import type { KundaliLang } from "./KundaliFormCard.i18n";
import type { KundaliFieldErrors } from "./KundaliFormCard.validation";
import type { KundaliField } from "@/lib/analytics-kundali";

type ProgressiveStepCopy = { title: string; body: string; nextLabel: string };

export type KundaliProgressiveCopy = Record<
  KundaliLang,
  {
    progressLabel: string;
    backLabel: string;
    emailToggle: string;
    steps: readonly [ProgressiveStepCopy, ProgressiveStepCopy, ProgressiveStepCopy];
  }
>;

export type KundaliProgressiveStep = 0 | 1 | 2;

export function progressiveStepForField(field: KundaliField): KundaliProgressiveStep {
  if (field === "name" || field === "birthDate") return 0;
  if (field === "phone" || field === "email") return 2;
  return 1;
}

export function progressiveStepForErrors(
  errors: KundaliFieldErrors
): KundaliProgressiveStep | null {
  if (errors.name || errors.birthDate) return 0;
  if (errors.birthTime || errors.birthPlace) return 1;
  if (errors.phone || errors.email) return 2;
  return null;
}
